(() => {
  if (window.__F24MobileMegaMenuLoaded) return;
  window.__F24MobileMegaMenuLoaded = true;

  const esc = (s) => String(s || '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const focusableSelector = 'a[href], button:not([disabled]), summary, input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  const build = () => {
    const header = document.querySelector('.f24-header-preview');
    const nav = header?.querySelector('.f24-mega-nav');
    const actions = header?.querySelector('.f24-header-preview__actions');
    if (!header || !nav || !actions || header.dataset.mobileMenuReady) return;
    header.dataset.mobileMenuReady = '1';

    const toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'f24-mobile-menu-toggle';
    toggle.setAttribute('aria-label', 'Menü öffnen');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-controls', 'f24-mobile-menu-drawer');
    toggle.innerHTML = '<span class="f24-mobile-menu-toggle__icon" aria-hidden="true"></span>';
    actions.insertBefore(toggle, actions.firstChild);

    const backdrop = document.createElement('div');
    backdrop.className = 'f24-mobile-menu-backdrop';

    const drawer = document.createElement('aside');
    drawer.id = 'f24-mobile-menu-drawer';
    drawer.className = 'f24-mobile-menu-drawer';
    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-modal', 'true');
    drawer.setAttribute('aria-label', 'Hauptmenü');
    drawer.setAttribute('aria-hidden', 'true');
    drawer.innerHTML = '<div class="f24-mobile-menu-drawer__head"><h2 class="f24-mobile-menu-drawer__title">Menü</h2><button class="f24-mobile-menu-close" type="button" aria-label="Menü schließen">×</button></div><div class="f24-mobile-menu-drawer__body"></div>';
    const body = drawer.querySelector('.f24-mobile-menu-drawer__body');

    nav.querySelectorAll(':scope > .f24-mega-nav__item').forEach((item) => {
      const trigger = item.querySelector(':scope > .f24-mega-nav__trigger');
      if (!trigger) return;
      const details = document.createElement('details');
      details.className = 'f24-mobile-menu-section' + (trigger.classList.contains('is-highlight') ? ' is-highlight' : '');
      const summary = document.createElement('summary');
      summary.textContent = trigger.textContent.trim();
      details.appendChild(summary);
      const content = document.createElement('div');
      content.className = 'f24-mobile-menu-section__content';
      const topLink = document.createElement('a');
      topLink.className = 'f24-mobile-menu-link';
      topLink.href = trigger.href;
      topLink.innerHTML = '<strong>Alle ' + esc(trigger.textContent.trim()) + ' anzeigen</strong>';
      content.appendChild(topLink);

      item.querySelectorAll('.f24-mega-nav__col').forEach((col) => {
        const group = document.createElement('div');
        group.className = 'f24-mobile-menu-group';
        const title = col.querySelector('h3');
        if (title) {
          const h = document.createElement('p');
          h.className = 'f24-mobile-menu-group__title';
          h.textContent = title.textContent.trim();
          group.appendChild(h);
        }
        col.querySelectorAll('a').forEach((a) => {
          const link = document.createElement('a');
          link.className = 'f24-mobile-menu-link';
          link.href = a.href;
          link.textContent = a.textContent.trim();
          group.appendChild(link);
        });
        content.appendChild(group);
      });
      details.appendChild(content);
      body.appendChild(details);
    });

    nav.querySelectorAll(':scope > a.f24-mega-nav__trigger').forEach((a) => {
      const link = document.createElement('a');
      link.className = 'f24-mobile-menu-direct' + (a.classList.contains('is-highlight') ? ' is-highlight' : '');
      link.href = a.href;
      link.textContent = a.textContent.trim();
      body.appendChild(link);
    });

    document.body.append(backdrop, drawer);

    const close = (returnFocus = true) => {
      const focusWasInside = drawer.contains(document.activeElement);
      drawer.classList.remove('is-open');
      backdrop.classList.remove('is-open');
      document.body.classList.remove('f24-mobile-menu-open');
      drawer.setAttribute('aria-hidden', 'true');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', 'Menü öffnen');
      if (returnFocus && focusWasInside) toggle.focus();
    };

    const open = () => {
      drawer.classList.add('is-open');
      backdrop.classList.add('is-open');
      document.body.classList.add('f24-mobile-menu-open');
      drawer.setAttribute('aria-hidden', 'false');
      toggle.setAttribute('aria-expanded', 'true');
      toggle.setAttribute('aria-label', 'Menü schließen');
      drawer.querySelector('.f24-mobile-menu-close')?.focus();
    };

    const trapFocus = (event) => {
      if (!drawer.classList.contains('is-open') || event.key !== 'Tab') return;
      const focusable = Array.from(drawer.querySelectorAll(focusableSelector))
        .filter((element) => element.offsetParent !== null && !element.hasAttribute('hidden'));
      if (!focusable.length) {
        event.preventDefault();
        return;
      }
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    };

    toggle.addEventListener('click', open);
    backdrop.addEventListener('click', () => close(true));
    drawer.querySelector('.f24-mobile-menu-close')?.addEventListener('click', () => close(true));
    drawer.addEventListener('click', (event) => { if (event.target.closest('a')) close(false); });
    document.addEventListener('keydown', (event) => {
      if (!drawer.classList.contains('is-open')) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        close(true);
        return;
      }
      trapFocus(event);
    });
    window.matchMedia('(min-width: 990px)').addEventListener('change', (event) => { if (event.matches) close(false); });
  };

  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', build, { once: true }) : build();
  document.addEventListener('shopify:section:load', build);
})();
